import React from 'react';
import './TicketItem.css';
import { useNavigate } from 'react-router-dom';
import { Ticket } from '../../../context/ProfileContext';
import { ReactComponent as ProfileIcon } from '../../../assets/Ticket Profile 1.svg';
import { ReactComponent as UpArrowIcon } from '../../../assets/Up 1.svg';
import { Typography, Box } from '@mui/material';

interface TicketItemProps {
  ticket: Ticket;
}

const TicketItem: React.FC<TicketItemProps> = ({ ticket }) => {
  const navigate = useNavigate();
  const handlenavigation = () => {
    navigate(`/supervisor/ticket/${ticket._id}`);
  };

  return (
    <Box
      className="ticket"
      sx={{
        width: { md: '400px' },
        padding: { xs: '20px', sm: '28px' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'start',
        }}
      >
        <Box
          sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
        >
          <Box
            sx={{
              minWidth: '30px',
              minHeight: '30px',
              backgroundColor: '#171717',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <ProfileIcon
              style={{
                width: '20px', // Icon size
                height: '20px',
                minWidth: '20px',
                minHeight: '20px',
              }}
            />
          </Box>
          <Box px={2} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: '14px', md: '14px' },
                textAlign: 'left',
                color: '#FFFFFC',
                fontWeight: '600',
              }}
            >
              {ticket.profileId.firstName} {ticket.profileId.lastName}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                //gap: { lg: 6 },  // Adjusts spacing based on screen size
                flexDirection: { xs: 'column', lg: 'row' },
                alignItems: { xs: 'flex-start', lg: 'center' },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: { xs: '12px', sm: '12px', md: '12px' },
                  color: '#535353',
                }}
              >
                {ticket.userId.email}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: { xs: '12px', sm: '12px', md: '12px' },
                  color: '#535353',
                }}
              >
                <Box
                  component="span"
                  sx={{
                    display: {
                      xs: 'none',
                      sm: 'none',
                      md: 'none',
                      lg: 'inline',
                    },
                  }}
                >
                  {'\u00A0'}
                  {'\u00A0'}
                  {'\u00A0'}
                </Box>{' '}
                +1 {ticket.profileId.phone}
              </Typography>
            </Box>
          </Box>
        </Box>
        <UpArrowIcon
          onClick={handlenavigation}
          style={{
            width: '20px', // Arrow icon size
            height: '20px',
            minWidth: '18px',
            minHeight: '18px',
            cursor: 'pointer',
          }}
        />
      </Box>
      <Typography
        variant="body1"
        sx={{
          pt: '10px',
          color: '#DFDFDF',
          marginBottom: '3vh',
          fontWeight: '400',
          textAlign: 'left',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          wordWrap: 'break-word',
        }}
      >
        {ticket.description}
      </Typography>
      {ticket.supportQueryImage && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
          }}
        >
          <img
            src={ticket.supportQueryImage}
            alt="Support Query"
            className="query-image"
            style={{
              width: '100%',
              height: 'auto',
              borderRadius: '8px',
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default TicketItem;
